// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .editorInput {
  min-height: 150px;
  resize: none;
  font-size: 15px;
  caret-color: rgb(5, 5, 5);
  position: relative;
  tab-size: 1;
  outline: 0;
  padding: 15px 10px;
  caret-color: #444;
} */

.editor_editor__ltr__060r0 {
  text-align: left;
}

.editor_editor__rtl__aayG- {
  text-align: right;
}

.editor_placeholder__XtUzW {
  position: absolute;
  top: 15px;
  left: 10px;

  display: inline-block;
  overflow: hidden;

  -webkit-user-select: none;

          user-select: none;
  text-overflow: ellipsis;
  pointer-events: none;

  color: #999;

  font-size: 15px;
}

.editor_editor__textBold__jkGuD {
  font-weight: bold;
}

.editor_editor__textItalic__0ynd2 {
  font-style: italic;
}

.editor_editor__textUnderline__B8LmV {
  text-decoration: underline;
}

.editor_editor__textStrikethrough__GvpDz {
  text-decoration: line-through;
}

.editor_editor__textUnderlineStrikethrough__6f9Ch {
  text-decoration: underline line-through;
}

.editor_editor__textCode__QFsNJ {
  padding: 1px 0.25rem;

  background-color: rgb(240 242 245);

  font-family: Menlo, Consolas, Monaco, monospace;
  font-size: 94%;
}

.editor_editor__link__9zSQe {
  text-decoration: none;

  color: rgb(33 111 219);
}

.editor_editor__image__\\+4ewq {
  position: relative;

  display: inline-block;

  margin: 0;
  padding: 0;

  cursor: default;
  -webkit-user-select: none;
          user-select: none;

  border-radius: 5px;
}

img {
  max-width: 100%;

  cursor: default;

  border-radius: 5px;
}

.editor_tree-view-output__jE4nA {
  position: relative;

  display: block;
  overflow: auto;

  max-height: 250px;
  margin: 1px auto 10px;
  padding: 5px;

  white-space: pre-wrap;

  color: #fff;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  background: #222;

  font-size: 12px;
  line-height: 14px;
}

.editor_editor__code__aE3pr {
  position: relative;

  display: block;

  /* white-space: pre; */
  overflow-x: auto;

  margin: 0;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 8px 8px 8px 52px;

  tab-size: 2;

  background-color: rgb(240 242 245);

  font-family: Menlo, Consolas, Monaco, monospace;
  font-size: 13px;
  line-height: 1.53;
}

.editor_editor__code__aE3pr::before {
  position: absolute;
  top: 0;
  left: 0;

  min-width: 25px;
  padding: 8px;

  content: attr(data-gutter);
  text-align: right;
  white-space: pre-wrap;

  color: #777;
  border-right: 1px solid #ccc;
  background-color: #eee;
}

.editor_editor__code__aE3pr::after {
  position: absolute;
  top: 0;
  right: 3px;

  padding: 3px;

  content: attr(data-highlight-language);
  text-transform: uppercase;

  color: rgb(0 0 0 / 50%);

  font-size: 10px;
}

.editor_editor__tokenComment__9xQE\\+ {
  color: slategray;
}

.editor_editor__tokenPunctuation__A-sd3 {
  color: #999;
}

.editor_editor__tokenProperty__1I6Ca {
  color: #905;
}

.editor_editor__tokenSelector__7GwBL {
  color: #690;
}

.editor_editor__tokenOperator__mApqM {
  color: #9a6e3a;
}

.editor_editor__tokenAttr__Jj-l4 {
  color: #07a;
}

.editor_editor__tokenVariable__rz-bU {
  color: #e90;
}

.editor_editor__tokenFunction__dFaIq {
  color: #dd4a68;
}

.editor_editor__paragraph__4\\+COl {
  position: relative;

  margin: 0;
  margin-bottom: 8px;

  font-family: "Helvetica Thin", sans-serif;

  font-size: 12pt;
  line-height: 14pt;
}

.editor_editor__paragraph__4\\+COl:last-child {
  margin-bottom: 4px;
}

.editor_editor__h1__d2B4Z {
  margin: 20px 0 10px;
  padding: 0;

  font-family: "HelveticaNeue Light", sans-serif;

  font-size: 24pt;
  line-height: 28pt;
}

.editor_editor__h2__NwoK4 {
  margin: 20px 0 10px;
  padding: 0;

  font-family: "HelveticaNeue Light", sans-serif;

  font-size: 20pt;
  line-height: 24pt;
}

.editor_editor__h3__mGvCN {
  margin: 20px 0 10px;
  padding: 0;

  font-family: "HelveticaNeue Bold", sans-serif;

  font-size: 16pt;
  font-weight: 600;
  line-height: 18pt;
}

.editor_editor__h4__L5yBu {
  margin: 10px 0;
  padding: 0;

  font-family: "HelveticaNeue Medium", sans-serif;

  font-size: 12pt;
  line-height: 16pt;
}

.editor_editor__h5__9wIgv {
  margin: 10px 0;
  padding: 0;

  color: rgb(0 0 0 / 80%);

  font-family: "HelveticaNeue Medium", sans-serif;
  font-size: 12pt;
  line-height: 14pt;
}

.editor_editor__h1__d2B4Z:first-child,
.editor_editor__h2__NwoK4:first-child,
.editor_editor__h3__mGvCN:first-child,
.editor_editor__h4__L5yBu:first-child,
.editor_editor__h5__9wIgv:first-child {
  margin-top: 0;
}

.editor_editor__h1__d2B4Z:last-child,
.editor_editor__h2__NwoK4:last-child,
.editor_editor__h3__mGvCN:last-child,
.editor_editor__h4__L5yBu:last-child,
.editor_editor__h5__9wIgv:last-child {
  margin-bottom: 4px;
}

.editor_editor__quote__EEZP0 {
  margin: 0;
  margin-left: 5px;
  padding-left: 16px;

  color: rgb(101 103 107);
  border-left: 4px solid rgb(206 208 212);

  font-size: 15px;
  line-height: 24px;
}

.editor_editor__listOl__mV7cr {
  /* margin-left: 16px; */
  list-style-position: inside;

  line-height: 24px;
}

.editor_editor__listUl__VAnOV {
  list-style-position: inside;

  line-height: 24px;
}

.editor_editor__listItem__pItS7 {
  margin: 8px 0;

  line-height: 24px;
}

.editor_editor__nestedListItem__IiV4B {
  list-style-type: none;

  line-height: 24px;
}

.editor_editor__mention__Q8pkP {
  display: inline-block;

  max-width: 605px;
}

pre::-webkit-scrollbar {
  width: 10px;

  background: transparent;
}

pre::-webkit-scrollbar-thumb {
  background: #999;
}
`, "",{"version":3,"sources":["webpack://./src/components/CommentEditor/theme/editor.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;GAUG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;;EAEV,qBAAqB;EACrB,gBAAgB;;EAEhB,yBAAiB;;UAAjB,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;;EAEpB,WAAW;;EAEX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;;EAEpB,kCAAkC;;EAElC,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,qBAAqB;;EAErB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;;EAElB,qBAAqB;;EAErB,SAAS;EACT,UAAU;;EAEV,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;;EAEjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;;EAEf,eAAe;;EAEf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;;EAElB,cAAc;EACd,cAAc;;EAEd,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;;EAEZ,qBAAqB;;EAErB,WAAW;EACX,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;;EAEhB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;;EAElB,cAAc;;EAEd,sBAAsB;EACtB,gBAAgB;;EAEhB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,yBAAyB;;EAEzB,WAAW;;EAEX,kCAAkC;;EAElC,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;;EAEP,eAAe;EACf,YAAY;;EAEZ,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;;EAErB,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;;EAEV,YAAY;;EAEZ,sCAAsC;EACtC,yBAAyB;;EAEzB,uBAAuB;;EAEvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;;EAElB,SAAS;EACT,kBAAkB;;EAElB,yCAAyC;;EAEzC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,UAAU;;EAEV,8CAA8C;;EAE9C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,UAAU;;EAEV,8CAA8C;;EAE9C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,UAAU;;EAEV,6CAA6C;;EAE7C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,UAAU;;EAEV,+CAA+C;;EAE/C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,UAAU;;EAEV,uBAAuB;;EAEvB,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;;EAElB,uBAAuB;EACvB,uCAAuC;;EAEvC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;;EAE3B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;;EAE3B,iBAAiB;AACnB;;AAEA;EACE,aAAa;;EAEb,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;;EAErB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;;EAErB,gBAAgB;AAClB;;AAEA;EACE,WAAW;;EAEX,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* .editorInput {\n  min-height: 150px;\n  resize: none;\n  font-size: 15px;\n  caret-color: rgb(5, 5, 5);\n  position: relative;\n  tab-size: 1;\n  outline: 0;\n  padding: 15px 10px;\n  caret-color: #444;\n} */\n\n.editor__ltr {\n  text-align: left;\n}\n\n.editor__rtl {\n  text-align: right;\n}\n\n.placeholder {\n  position: absolute;\n  top: 15px;\n  left: 10px;\n\n  display: inline-block;\n  overflow: hidden;\n\n  user-select: none;\n  text-overflow: ellipsis;\n  pointer-events: none;\n\n  color: #999;\n\n  font-size: 15px;\n}\n\n.editor__textBold {\n  font-weight: bold;\n}\n\n.editor__textItalic {\n  font-style: italic;\n}\n\n.editor__textUnderline {\n  text-decoration: underline;\n}\n\n.editor__textStrikethrough {\n  text-decoration: line-through;\n}\n\n.editor__textUnderlineStrikethrough {\n  text-decoration: underline line-through;\n}\n\n.editor__textCode {\n  padding: 1px 0.25rem;\n\n  background-color: rgb(240 242 245);\n\n  font-family: Menlo, Consolas, Monaco, monospace;\n  font-size: 94%;\n}\n\n.editor__link {\n  text-decoration: none;\n\n  color: rgb(33 111 219);\n}\n\n.editor__image {\n  position: relative;\n\n  display: inline-block;\n\n  margin: 0;\n  padding: 0;\n\n  cursor: default;\n  user-select: none;\n\n  border-radius: 5px;\n}\n\nimg {\n  max-width: 100%;\n\n  cursor: default;\n\n  border-radius: 5px;\n}\n\n.tree-view-output {\n  position: relative;\n\n  display: block;\n  overflow: auto;\n\n  max-height: 250px;\n  margin: 1px auto 10px;\n  padding: 5px;\n\n  white-space: pre-wrap;\n\n  color: #fff;\n  border-bottom-right-radius: 10px;\n  border-bottom-left-radius: 10px;\n  background: #222;\n\n  font-size: 12px;\n  line-height: 14px;\n}\n\n.editor__code {\n  position: relative;\n\n  display: block;\n\n  /* white-space: pre; */\n  overflow-x: auto;\n\n  margin: 0;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  padding: 8px 8px 8px 52px;\n\n  tab-size: 2;\n\n  background-color: rgb(240 242 245);\n\n  font-family: Menlo, Consolas, Monaco, monospace;\n  font-size: 13px;\n  line-height: 1.53;\n}\n\n.editor__code::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  min-width: 25px;\n  padding: 8px;\n\n  content: attr(data-gutter);\n  text-align: right;\n  white-space: pre-wrap;\n\n  color: #777;\n  border-right: 1px solid #ccc;\n  background-color: #eee;\n}\n\n.editor__code::after {\n  position: absolute;\n  top: 0;\n  right: 3px;\n\n  padding: 3px;\n\n  content: attr(data-highlight-language);\n  text-transform: uppercase;\n\n  color: rgb(0 0 0 / 50%);\n\n  font-size: 10px;\n}\n\n.editor__tokenComment {\n  color: slategray;\n}\n\n.editor__tokenPunctuation {\n  color: #999;\n}\n\n.editor__tokenProperty {\n  color: #905;\n}\n\n.editor__tokenSelector {\n  color: #690;\n}\n\n.editor__tokenOperator {\n  color: #9a6e3a;\n}\n\n.editor__tokenAttr {\n  color: #07a;\n}\n\n.editor__tokenVariable {\n  color: #e90;\n}\n\n.editor__tokenFunction {\n  color: #dd4a68;\n}\n\n.editor__paragraph {\n  position: relative;\n\n  margin: 0;\n  margin-bottom: 8px;\n\n  font-family: \"Helvetica Thin\", sans-serif;\n\n  font-size: 12pt;\n  line-height: 14pt;\n}\n\n.editor__paragraph:last-child {\n  margin-bottom: 4px;\n}\n\n.editor__h1 {\n  margin: 20px 0 10px;\n  padding: 0;\n\n  font-family: \"HelveticaNeue Light\", sans-serif;\n\n  font-size: 24pt;\n  line-height: 28pt;\n}\n\n.editor__h2 {\n  margin: 20px 0 10px;\n  padding: 0;\n\n  font-family: \"HelveticaNeue Light\", sans-serif;\n\n  font-size: 20pt;\n  line-height: 24pt;\n}\n\n.editor__h3 {\n  margin: 20px 0 10px;\n  padding: 0;\n\n  font-family: \"HelveticaNeue Bold\", sans-serif;\n\n  font-size: 16pt;\n  font-weight: 600;\n  line-height: 18pt;\n}\n\n.editor__h4 {\n  margin: 10px 0;\n  padding: 0;\n\n  font-family: \"HelveticaNeue Medium\", sans-serif;\n\n  font-size: 12pt;\n  line-height: 16pt;\n}\n\n.editor__h5 {\n  margin: 10px 0;\n  padding: 0;\n\n  color: rgb(0 0 0 / 80%);\n\n  font-family: \"HelveticaNeue Medium\", sans-serif;\n  font-size: 12pt;\n  line-height: 14pt;\n}\n\n.editor__h1:first-child,\n.editor__h2:first-child,\n.editor__h3:first-child,\n.editor__h4:first-child,\n.editor__h5:first-child {\n  margin-top: 0;\n}\n\n.editor__h1:last-child,\n.editor__h2:last-child,\n.editor__h3:last-child,\n.editor__h4:last-child,\n.editor__h5:last-child {\n  margin-bottom: 4px;\n}\n\n.editor__quote {\n  margin: 0;\n  margin-left: 5px;\n  padding-left: 16px;\n\n  color: rgb(101 103 107);\n  border-left: 4px solid rgb(206 208 212);\n\n  font-size: 15px;\n  line-height: 24px;\n}\n\n.editor__listOl {\n  /* margin-left: 16px; */\n  list-style-position: inside;\n\n  line-height: 24px;\n}\n\n.editor__listUl {\n  list-style-position: inside;\n\n  line-height: 24px;\n}\n\n.editor__listItem {\n  margin: 8px 0;\n\n  line-height: 24px;\n}\n\n.editor__nestedListItem {\n  list-style-type: none;\n\n  line-height: 24px;\n}\n\n.editor__mention {\n  display: inline-block;\n\n  max-width: 605px;\n}\n\npre::-webkit-scrollbar {\n  width: 10px;\n\n  background: transparent;\n}\n\npre::-webkit-scrollbar-thumb {\n  background: #999;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor__ltr": `editor_editor__ltr__060r0`,
	"editor__rtl": `editor_editor__rtl__aayG-`,
	"placeholder": `editor_placeholder__XtUzW`,
	"editor__textBold": `editor_editor__textBold__jkGuD`,
	"editor__textItalic": `editor_editor__textItalic__0ynd2`,
	"editor__textUnderline": `editor_editor__textUnderline__B8LmV`,
	"editor__textStrikethrough": `editor_editor__textStrikethrough__GvpDz`,
	"editor__textUnderlineStrikethrough": `editor_editor__textUnderlineStrikethrough__6f9Ch`,
	"editor__textCode": `editor_editor__textCode__QFsNJ`,
	"editor__link": `editor_editor__link__9zSQe`,
	"editor__image": `editor_editor__image__+4ewq`,
	"tree-view-output": `editor_tree-view-output__jE4nA`,
	"editor__code": `editor_editor__code__aE3pr`,
	"editor__tokenComment": `editor_editor__tokenComment__9xQE+`,
	"editor__tokenPunctuation": `editor_editor__tokenPunctuation__A-sd3`,
	"editor__tokenProperty": `editor_editor__tokenProperty__1I6Ca`,
	"editor__tokenSelector": `editor_editor__tokenSelector__7GwBL`,
	"editor__tokenOperator": `editor_editor__tokenOperator__mApqM`,
	"editor__tokenAttr": `editor_editor__tokenAttr__Jj-l4`,
	"editor__tokenVariable": `editor_editor__tokenVariable__rz-bU`,
	"editor__tokenFunction": `editor_editor__tokenFunction__dFaIq`,
	"editor__paragraph": `editor_editor__paragraph__4+COl`,
	"editor__h1": `editor_editor__h1__d2B4Z`,
	"editor__h2": `editor_editor__h2__NwoK4`,
	"editor__h3": `editor_editor__h3__mGvCN`,
	"editor__h4": `editor_editor__h4__L5yBu`,
	"editor__h5": `editor_editor__h5__9wIgv`,
	"editor__quote": `editor_editor__quote__EEZP0`,
	"editor__listOl": `editor_editor__listOl__mV7cr`,
	"editor__listUl": `editor_editor__listUl__VAnOV`,
	"editor__listItem": `editor_editor__listItem__pItS7`,
	"editor__nestedListItem": `editor_editor__nestedListItem__IiV4B`,
	"editor__mention": `editor_editor__mention__Q8pkP`
};
export default ___CSS_LOADER_EXPORT___;
